import { Table, Tooltip } from "antd";
import ChantPopConfirm from "../../../CommonComponents/ChantTooltip/ChantPopConfirm";
import React, { useState, useEffect } from "react";
import {
  deletePolls,
  fbGetClubAdminPolls,
} from "../../../services/firebaseService/endPoints/clubAdmin/polls";
import { useNavigate } from "react-router-dom";
import ChantContainer from "../../../CommonComponents/ChantContainer";
import {
  ChantButton,
  DescriptionText,
  ScreenHeader,
} from "../../../CommonComponents";
import { toast } from "react-toastify";
import logger from "../../../utils/logger";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import {
  getDayjsFromTimestamp,
  sortObjectByNumber,
} from "../../../utils/helper";
import dayjs from "dayjs";
import ViewMoreText from "../../../CommonComponents/ViewMore/ViewMore";
import useAdminDataStore, { selectCurrentGroupData } from "../../../store/adminData/adminData";

const ParentAdminPolls = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [tableData, setTableData] = useState([]);

  const groupData = useAdminDataStore(selectCurrentGroupData);

  // const handlePostLive = (id) => {
  //   setIsLoading(true);

  //   postLive(id).then(() => {
  //     fbGetClubAdminPolls(clubId, ["tzhCxrXvlC6sVceEsIv0"]).then((polls) => {
  //       setTableData(polls);
  //       setIsLoading(false);
  //     });
  //   });
  // };

  // const handleEdit = (row) => {
  //   navigate(`/clubadmin/polls/edit/${clubId}_polls/${row.id}`);
  // };

  const handleDelete = async (row) => {
    try {
      const { success, message } = await deletePolls(groupData?.id, row.id);
      if (success) {
        const polls = await fbGetClubAdminPolls(groupData.id);
        setTableData(polls);
        setIsLoading(false);
      } else {
        toast.error(message);
      }
    } catch (error) {
      toast.error("Failed to delete poll");
      logger.error("Error deleting poll:", error);
    }
  };

  const initializeState = async () => {
    try {
      if (!groupData?.id) return;
      setIsLoading(true);

      const polls = await fbGetClubAdminPolls(groupData?.id);
      setTableData(polls);
    } catch (error) {
      logger.error("Error fetching polls:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleEditPoll = (id) => {
    navigate(`/clubadmin/polls/edit/${id}`);
  };

  useEffect(() => {
    initializeState();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [groupData?.id]);

  const columns = [
    {
      title: "Actions",
      width: 100,
      align: "center",
      render: (data) => {
        return (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {data && data.id && (
              <div style={{ display: "flex", gap: "8px" }}>
                <i
                  className="ml-3"
                  style={{ cursor: "pointer" }}
                  onClick={() => handleEditPoll(data?.id)}
                >
                  <EditOutlined
                    style={{ fontSize: "18px", color: "#8c8c8c" }}
                  />
                </i>

                <ChantPopConfirm
                  title="Are you sure you want to delete this poll?"
                  onConfirm={() => handleDelete(data?.id)}
                >
                  <i className="ml-3" style={{ cursor: "pointer" }}>
                    <DeleteOutlined
                      style={{ fontSize: "18px", color: "#8c8c8c" }}
                    />
                  </i>
                </ChantPopConfirm>
              </div>
            )}
          </div>
        );
      },
    },
    {
      title: "Date Posted",
      key: "addedOn",
      dataIndex: "addedOn",
      className: "header-white",
      width: 150,
      render: (data) =>
        data ? getDayjsFromTimestamp(data).format("Do MMM, YYYY") : "",
      sorter: (a, b) => sortObjectByNumber(a, b, "addedOn"),
    },

    {
      title: "Time Remaining",
      key: "timeRemaining",
      dataIndex: "closesOn",
      className: "header-white",
      width: 150,
      render: (data) => {
        const parsedDate = getDayjsFromTimestamp(data);
        if (!parsedDate) {
          return "N/A";
        }
        const now = dayjs();
        let timeRemaining = parsedDate.diff(now, "seconds");

        if (timeRemaining <= 0) {
          return "Closed";
        }

        if (timeRemaining < 60) {
          return `${timeRemaining} sec`;
        } else if (timeRemaining < 3600) {
          return `${Math.round(timeRemaining / 60)} minutes`;
        } else if (timeRemaining < 86400) {
          const hours = Math.round(timeRemaining / 3600);
          return `${hours} ${hours === 1 ? "hour" : "hours"}`;
        } else {
          const days = Math.round(timeRemaining / 86400);
          return `${days} ${days === 1 ? "day" : "days"}`;
        }
      },
    },

    // {
    //   title: "Groups",
    //   key: "groups",
    //   className: "header-white",
    //   dataIndex: "groups",
    //   width: 150,
    //   render: (groups) => {
    //     return (
    //       <ul style={{ listStyle: "none" }}>
    //         {groups?.map((param) => {
    //           let group = allGroups?.find((group) => group.id === param);
    //           if (group) {
    //             return <li key={group.id}>{group.groupName}</li>;
    //           } else {
    //             return <li key={param}>{param}</li>;
    //           }
    //         })}
    //       </ul>
    //     );
    //   },
    // },

    {
      title: "Question",
      key: "question",
      className: "header-white",
      dataIndex: "desc",
      width: 300,
      ellipsis: true,
      render: (data) => <ViewMoreText text={data} maxLength={100} />,
    },
    {
      title: "Responses(%)",
      key: "response",
      className: "header-white",
      width: 300,
      render: (data) => {
        if (!data) return null;
        const currentTime = dayjs().unix();

        const sortedStats = Object.entries(data?.stats || {}).sort(
          (a, b) => b[1] - a[1],
        );

        if (data.isActive || currentTime > data.closesOn) {
          return (
            <div>
              {data.stats
                ? sortedStats.map(([key, value], index) => (
                    <div key={index}>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <div style={{ display: "flex", gap: "4px" }}>
                          <span>•</span>
                          <span>{key}</span>{" "}
                        </div>
                        <span
                          style={{ color: "grey" }}
                        >{`${Math.round(value)}%`}</span>{" "}
                      </div>
                    </div>
                  ))
                : null}
            </div>
          );
        } else {
          return (
            <div>
              {Array.from({ length: 5 }, (_, index) => index)
                .filter((index) => data[`op${index + 1}`])
                .map((index) => (
                  <div key={index}>
                    <div style={{ display: "flex", gap: "4px" }}>
                      <span>•</span>
                      <div key={index}>{data[`op${index + 1}`]?.name}</div>
                    </div>
                  </div>
                ))}
            </div>
          );
        }
      },
    },
    {
      title: "Total Responses",
      key: "entries",
      className: "header-white",
      dataIndex: "noOfPolls",
      width: 150,
      render: (entries) => entries || 0,
    },
    {
      title: "Feedback",
      key: "provideFeedBack",
      className: "header-white",
      dataIndex: "provideFeedBack",
      ellipsis: true,
      width: 150,
      render: (data) => (data ? "Yes" : "No"),
    },
    {
      title: (
        <Tooltip title="Show responses to all members?" placement="topLeft">
          Show Responses
        </Tooltip>
      ),
      key: "showEntriesToMembers",
      className: "header-white",
      dataIndex: "showEntriesToMembers",
      ellipsis: true,
      width: 150,
      render: (data) => (data ? "Yes" : "No"),
    },
    {
      title: "Allow Fan Vote?",
      key: "showForFans",
      className: "header-white",
      dataIndex: "showForFans",
      width: 150,
      render: (data) => (data ? "Yes" : "No"),
    },
  ];

  return (
    <ChantContainer>
      <ScreenHeader
        elementCount={tableData?.length}
        title="Polls"
        actions={
          <div>
            <ChantButton
              onClick={() => {
                navigate("/clubadmin/polls/create");
              }}
            >
              Create New
            </ChantButton>
          </div>
        }
      />

      <div
        style={{
          backgroundColor: "white",
          padding: "12px",
          marginTop: "2px",
        }}
      >
        <DescriptionText>
          Polls can be created by admin/leaders in the app and dashboard.
          Options exist to gather additional feedback (max 150 characters) and
          to show individual responses to members. You can also include Fans
          (non-members) if that role is used by the group.
        </DescriptionText>
      </div>

      <Table
        bordered
        columns={columns}
        loading={isLoading}
        dataSource={tableData}
        pagination={{
          position: ["bottomLeft"],
          defaultPageSize: 100,
          showSizeChanger: true,
          pageSizeOptions: [10, 20, 50, 100],
        }}
        rowKey="id"
        key="id"
        scroll={{ x: "max-content" }}
      />
    </ChantContainer>
  );
};

export default ParentAdminPolls;
